import React from "react";
import "./IndexSection.css";
import BIDButton from "../BIDButton/BIDButton";
import LinkWithLanguage from "../LinkWithLanguage/LinkWithLanguage";
import TEXT from "../../../utils/text/misc.json"

export default function IndexSection({
  title,
  subtitle,
  description,
  subtitle2 = '',
  description2 = '',
  to,
  to2 = '',
  image,
  imageAltText,
  isImgLeft,
  language
}) {
  return (
    <div className={"index-section-container" + (isImgLeft ? " reverse" : "")}>
      <div className="index-section-img-container">
        <img
          className="index-section-img"
          alt={imageAltText}
          src={require("./../../../images/dashboard/" + image)}
        />
      </div>
      <div className="index-section-text">
        <h1 className="index-section-title">{title}</h1>

        <p className="index-section-description">
          <span className="index-section-subtitle">{subtitle}</span>
          {description}
        </p>

        <LinkWithLanguage
          to={"/" + to}
          content={
            <div className="see-more-button">
              <BIDButton text={TEXT["seeMore"][language ?? "en"]} type={"dark"} size={"small"} />
            </div>
          }
        />

        {subtitle2 !== '' && description2 !== '' && to2 !== '' && (
          <>
            <p className="index-section-description" style={{marginTop: '20px'}}>
              <span className="index-section-subtitle">{subtitle2}</span>
              {description2}
            </p>

            <LinkWithLanguage
              to={"/" + to2}
              content={
                <div className="see-more-button">
                  <BIDButton text={TEXT["seeMore"][language ?? "en"]} type={"dark"} size={"small"} />
                </div>
              }
            />
          </>
        )}
      </div>
    </div>
  );
}
